<template>
  <svg
    class="custom-icon"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 2" clip-path="url(#clip0_1948_5709)">
      <g id="Vector">
        <path
          d="M27.3161 24.0173L21.3933 18.0944C22.6164 16.2496 23.3331 14.0412 23.3331 11.6667C23.3331 5.23356 18.0996 0 11.6666 0C5.23378 0 0 5.23384 0 11.6667C0 18.0998 5.2335 23.3334 11.6666 23.3334C14.0407 23.3334 16.2493 22.6167 18.0942 21.3935L24.017 27.3164C24.9274 28.2279 26.406 28.2279 27.3164 27.3164C28.2279 26.4058 28.2278 24.9279 27.3161 24.0173ZM3.50032 11.6666C3.50032 7.16322 7.16376 3.49987 11.6669 3.49987C16.1701 3.49987 19.8335 7.16336 19.8335 11.6666C19.8335 16.1699 16.1701 19.8333 11.6669 19.8333C7.16334 19.8333 3.50032 16.1698 3.50032 11.6666Z"
        />
        <path
          d="M13.4 7.4502C13.4 6.4837 12.6164 5.7002 11.65 5.7002C10.6835 5.7002 9.89995 6.4837 9.89995 7.45019V10H7.45C6.4835 10 5.7 10.7835 5.7 11.75C5.7 12.7165 6.4835 13.5 7.45 13.5H9.89995V15.9502C9.89995 16.9167 10.6835 17.7002 11.65 17.7002C12.6164 17.7002 13.4 16.9167 13.4 15.9502V13.5H15.95C16.9165 13.5 17.7 12.7165 17.7 11.75C17.7 10.7835 16.9165 10 15.95 10H13.4V7.4502Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1948_5709">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
